import { toCamel } from 'convert-keys'
import { defaultPartnerKey } from 'constants'
import { isExtensionContext } from 'helper'
import { isAnalyticsAllowed, isAnalyticsConsentManaged } from './consent'

const useStage = process.env.NODE_ENV === 'development'
const baseUrl = process.env.BASE_URL
const clientId = process.env.CLIENT_ID
const clientSecret = process.env.CLIENT_SECRET
const credentials = btoa(`${clientId}:${clientSecret}`)

// This is used for development only
/* istanbul ignore next */
function resolveAfter(seconds, value) {
  return new Promise(resolve => {
    setTimeout(() => resolve(value), seconds * 1000)
  })
}

function rejectUnlessOk(response) {
  if (response.ok) {
    return response.text().then(text => {
      return text ? JSON.parse(text) : {}
    })
  }
  return Promise.reject(response)
}

function post(path, body) {
  return fetch(`${baseUrl}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: `Basic ${credentials}`
    },
    body: JSON.stringify(body),
  })
    .then(rejectUnlessOk)
    .then(toCamel)
}

export function createOrUpdateRecipe(url, validateLiquor, partner, zipCode) {
  console.log('initializing', payload)

  /* istanbul ignore if */
  if (process.env.INTERCEPT_REQUEST) {
    return resolveAfter(1.5, toCamel(require('fixtures/externalRecipe.json')))
  }

  const payload = {
    url,
    check_liquor: validateLiquor
  }

  if (isAnalyticsConsentManaged()) payload.analyticsAllowed = isAnalyticsAllowed()
  if (partner != defaultPartnerKey) payload.partner = partner
  if (zipCode) payload.zipcode = zipCode

  // Safari will throw exception when access 'chrome'
  if (isExtensionContext()) {
    // promises are supported from Chrome 99+
    return chrome.runtime.sendMessage({ apiPayload: payload, useStage }).then(response => {
      if (response.success) {
        return toCamel(response.data)
      } else {
        if (typeof response.error.error === 'object') {
          // return all error messages
          return Promise.reject(Object.values(response.error.error))
        }
      }
    })
  }

  return post('/v3/widget/recipes/', payload)
    .then(recipe => {
      console.log('got shoppable recipe:', recipe)
      return recipe
    })
}

export function sendEvent(params) {
  if (!isAnalyticsAllowed()) return Promise.resolve()
  /* istanbul ignore if */
  if (process.env.INTERCEPT_REQUEST) {
    console.log('sending event', params)
    return resolveAfter(1, {})
  }

  const url = '/v3/widget/events/'
  const payload = [params]

  return post(url, { events: payload })
}
